/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum representing the various statuses of localities.
 */
export enum LocalitiesStatus {
    RAION = 'raion',
    CITY = 'city',
    MUNICIPAL_SECTOR = 'municipalSector',
    MUNICIPALITY = 'municipality',
    LOCALITY_WITHIN_THE_CITY_OR_MUNICIPALITY = 'localityWithinTheCityOrMunicipality',
    VILLAGE_OR_COMMUNE = 'villageOrCommune',
    LOCALITY_WITHIN_THE_VILLAGE_OR_COMMUNE = 'localityWithinTheVillageOrCommune',
}
